<template>
  <div id="purchase" :class="getClassName('purchase')">
    <div :class="getClassName('purchase__caption')">購入内容</div>
    <div :class="getClassName('purchase__cell')">
      <div :class="[...getClassName('purchase__summary'), 'purchase__summary--counter']">
        <span class="purchase__counter">❶</span>
        種類を選択してください。
      </div>
      <SelectColors :class="getClassName('purchase__colors')" :items="[item]" :media="media" v-model="form" />
    </div>
    <div :class="getClassName('purchase__cell')">
      <div :class="[...getClassName('purchase__summary'), 'purchase__summary--counter']">
        <span class="purchase__counter">❷</span>
        <template v-if="isCurtainMadomo"> 本体生地サイズを選択してください。 </template>
        <template v-else>サイズを選択してください。</template>
        <!-- <template v-if="isIronCurtainRail"><br />作成希望サイズは購入時備考欄にお書きください。</template> -->
        <a
          :class="getClassName('purchase__show-model')"
          @click="showModal(item.category.size_image)"
          v-if="item.category.size_image"
          >サイズの選び方</a
        >
      </div>
      <SelectSizes :class="getClassName('purchase__sizes')" :item="item" :media="media" v-model="form" />
    </div>
    <div :class="getClassName('purchase__cell')" v-if="isIronCurtainRail">
      <ApprovalIronCurtainRail :class="getClassName('purchase__ironcurtainrail')" :item="item" :media="media" v-model="form" @approvalIronCurtainRail="approvalIronCurtainRail"/>
    </div>
    <div :class="getClassName('purchase__cell')">
      <div :class="[...getClassName('purchase__summary'), 'purchase__summary--counter']">
        <span class="purchase__counter">❸</span>
        購入{{ item.unit }}数を選択してください。
        <template v-if="isCurtainMadomo"><br />両開きの場合は2枚ご購入ください。</template>
      </div>
      <InputQuantity :class="getClassName('purchase__quantity')" :item="item" :media="media" v-model="form" />
    </div>
    <div :class="getClassName('purchase__cell')" v-if="item.parts_categories.length > 0">
      <div :class="[...getClassName('purchase__summary'), 'purchase__summary--counter']">
        <span class="purchase__counter">❹</span>
        <template v-if="isCustomId1">
          <p>オプションパーツが必要な方はお選びください。<br />
          ※「kami」は同じ生地で製作する「共紐」8本がセットでの価格です。<br />
          ※別途オプションパーツをご購入いただいても「共紐」は付属されます。<br />
          ※オプションパーツが不要な場合は「パーツなし」をお選びください。</p>
        </template>
        <template v-else-if="isCustomId2">
          <p>生地とレールをつなぐパーツをお選びください。<br />
          ※パーツは８本セットが基本です<br />
          ※パーツが不要な場合は「パーツなし」をお選びください</p>
        </template>
        <template v-else-if="isCustomId4">
          <p>オプションパーツが必要な方はお選びください。<br />
          ※「ooasa」は同じ生地で製作する「共紐」8本がセットでの価格です<br />
          ※別途オプションパーツをご購入いただいても「共紐」は付属されます<br />
          ※オプションパーツが不要な場合は「パーツなし」をお選びください</p>
        </template>
        <template v-else-if="isCurtainMadomo">
          <p>生地とレールをつなぐパーツをお選びください。<br />
          <span v-if="!isCustomId3">リボンまたはボタンストラップをカーテンランナーにつなげて掛けたい方は、ランナー専用パーツも合わせてお選びください。<br /></span>
          ※パーツは８本セットが基本です<br />
          ※パーツが不要な場合は「パーツなし」をお選びください<br />
          <a v-if="!isCustomId3" href="#simulator" class="purchase__counter__simlator-link">※シミュレーションをしてみる</a>
          </p>
        </template>
        <template v-else-if="isMekakushiMadomo">
          <p>生地と突っ張り棒をつなぐパーツをお選びください。<br />
          ※パーツは８本セットが基本です<br />
          ※パーツが不要な場合は「パーツなし」をお選びください<br />
          <a v-if="!isCustomId5" href="#simulator" class="purchase__counter__simlator-link">※シミュレーションをしてみる</a>
          </p>
        </template>
        <template v-else-if="isLongApron">
          肩ひものリボンを2本お選びください。<br />
          前結びスタイルや男性がご使用の場合はロングリボンをお選びください。<br />
          <!-- 着脱可能なポケットもお選びいただけます。 -->
        </template>
        <template v-else-if="isCustomizedBag">持ち手（ストラップ）をお選びください。</template>
        <template v-else-if="isCushionCover">
          着せ替えクロス（10WAYクロス）が必要な方はお選びください。<br />
          クッションカバーの４角にあるボタンに取り付けてお使いいただけます。
        </template>
        <template v-else>パーツが必要な方はお選びください。</template>
        <a
          :class="getClassName('purchase__show-model')"
          @click="showModal(item.category.parts_image)"
          v-if="item.category.parts_image && !isCustomId1 && !isCustomId2 && !isCustomId3"
          >パーツの選び方</a
        >
      </div>
      <SelectParts :class="getClassName('purchase__parts')" :item="item" :media="media" v-model="form" :noPartsVueFlg="(isCurtainMadomo || isMekakushiMadomo) ? true : false" @noSelection="noSelection">
        <template v-slot:items>
          <div :class="getClassName('parts-items')" v-if="getParts.length > 0">
            <PartsItem
              v-for="(part, index) in getParts"
              :key="`${part.id}-${part.option.id}`"
              :item="part"
              :media="media"
              v-model="form.parts[index]"
              @remove-parts="removeParts"
            />
          </div>
        </template>
      </SelectParts>
    </div>
    <div :class="getClassName('purchase__cell')">
      <AddCart
        :class="getClassName('purchase__price')"
        :item="item"
        :form="form"
        :enable-cart="enableCart"
        :media="media"
        :noPartsVueFlg="(isCurtainMadomo || isMekakushiMadomo) ? true : false"
        :noPartsFlg="noPartsFlg"
        :isIronCurtainRail="isIronCurtainRail"
        :noApprovalIronCurtainRailFlg="noApprovalIronCurtainRailFlg"
        @alert="applyAlert"
      />
    </div>
    <PurchaseModal :visible="modal.visible" :content="modal.content" :media="media" @hide="hideModal" />
  </div>
</template>

<script>
import getClassName from '../../_mixins/getClassName';

import SelectColors from './SelectColors';
import SelectSizes from './SelectSizes';
import ApprovalIronCurtainRail from './ApprovalIronCurtainRail';
import InputQuantity from './InputQuantity';
import SelectParts from './SelectParts';
import PartsItem from './PartsItem';
import AddCart from './AddCart';
import PurchaseModal from './PurchaseModal';

export default {
  mixins: [getClassName],
  components: {
    SelectColors,
    SelectSizes,
    SelectParts,
    PartsItem,
    ApprovalIronCurtainRail,
    InputQuantity,
    AddCart,
    PurchaseModal,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    enableCart: {
      type: Boolean,
      required: true,
      default: true,
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      form: this.value,
      isFetching: false,
      modal: {
        visible: false,
        content: null,
      },
      noPartsFlg: false,
      noApprovalIronCurtainRailFlg: false,
    };
  },
  computed: {
    getParts() {
      if (this.form.parts.length === 0) return [];

      const partsItems = this.item.parts_categories.flatMap((category) => category.items);
      return this.form.parts.map((form) => {
        const [item] = partsItems.filter((item) => item.id === form.item_id);
        const [option] = item.options.filter((option) => option.id === form.item_option_id);
        return { ...item, option: option };
      });
    },
    isCurtainMadomo() {
      return this.item.category.slug === 'curtain-madomo';
    },
    isMekakushiMadomo() {
      return this.item.category.slug === 'mekakushi-madomo';
    },
    isLongApron() {
      return this.item.category.slug === 'long-apron';
    },
    is10WayCloth() {
      return this.item.category.slug === '10way-cloth';
    },
    isPlaceMat() {
      return this.item.category.slug === 'place-mat';
    },
    isCustomizedBag() {
      return this.item.category.slug === 'customized-bag';
    },
    isReversibleBag() {
      return this.item.category.slug === 'reversible-bag';
    },
    isCoaster() {
      return this.item.category.slug === 'coaster';
    },
    isCushionCover() {
      return this.item.category.slug === 'cushion-cover';
    },
    isPartsRail() {
      return this.item.category.slug === 'parts-rail';
    },
    isButtonStrap() {
      return this.item.category.slug === 'button-strap';
    },
    isRibbon() {
      return this.item.category.slug === 'ribbon';
    },
    isIronCurtainRail() {
      return this.item.category.slug === 'iron-curtain-rail';
    },
    isRing() {
      return this.item.category.slug === 'ring';
    },
    isRunnerRing() {
      return this.item.category.slug === 'runner-ring';
    },
    isLongRibbon() {
      return this.item.category.slug === 'long-ribbon';
    },
    isRectangularStrap() {
      return this.item.category.slug === 'rectangular-strap';
    },
    isPocket() {
      return this.item.category.slug === 'pocket';
    },
    isWoodenButton() {
      return this.item.category.slug === 'wooden-button';
    },
    isCustomId1() {
      // カーテンmadomo KAMIシリーズ
      return (this.item.id === 216
      || this.item.id === 217
      || this.item.id === 218
      || this.item.id === 219
      || this.item.id === 220
      || this.item.id === 221
      || this.item.id === 222
      || this.item.id === 223
      );
    },
    isCustomId2() {
      // カーテンmadomo ナグシリーズ
      return (this.item.id === 210
      || this.item.id === 211
      || this.item.id === 212
      || this.item.id === 213
      );
    },
    isCustomId3() {
      // カーテンmadomo ホノカシリーズ
      // ナチュラルカーテンmadomo
      // ・「パーツの選び方」、※シミュレーションをしてみる、文面の一部を削除
      return (this.item.id === 226
      || this.item.id === 228
      || this.item.id === 253
      );
    },
    isCustomId4() {
      // Ooasa カーテン・目隠し
      return (this.item.id === 255
      || this.item.id === 257
      || this.item.id === 256
      || this.item.id === 258
      );
    },
    isCustomId5() {
      // Ooasa カーテン・目隠し
      // ・※シミュレーションをしてみるを削除
      return (this.item.id === 224
      || this.item.id === 225
      || this.item.id === 254
      );
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.form = newValue;
      },
      immediate: true,
    },
    form: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true,
    },
  },
  methods: {
    applyAlert(alert) {
      this.$emit('alert', alert);
    },
    removeParts(part) {
      this.form = {
        ...this.form,
        parts: this.form.parts.filter(
          (form) =>
            form.item_id !== part.id ||
            form.item_color_id !== part.option.color.id ||
            form.item_size_id !== part.option.size.id ||
            form.item_option_id !== part.option.id
        ),
      };
    },
    showModal(content) {
      this.modal = {
        visible: true,
        content: content,
      };
    },
    hideModal() {
      this.modal = {
        visible: false,
        content: null,
      };
    },
    noSelection(noPartsFlg) {
      this.noPartsFlg = noPartsFlg;
    },
    approvalIronCurtainRail(approval) {
      this.noApprovalIronCurtainRailFlg = approval;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';
@import '../../_sass/mixins';

.purchase {
  width: 850px;
  margin: 45px auto 0;
  counter-reset: purchase;
  &--sp {
    width: 87.5%;
    padding-top: 23px;
    border-top: solid 1px currentcolor;
    margin: 23px auto 0;
  }
  &__caption {
    background: $color__cell;
    padding: 22.5px 0;
    border-top: solid 1px $color__line--item;
    border-right: solid 1px $color__line--item;
    border-left: solid 1px $color__line--item;
    text-align: center;
    &--sp {
      background: #8a8a8a;
      padding: 4px 0;
      color: #fff;
      font-size: 1.1rem;
      display: block;
    }
  }
  &__cell {
    border-top: solid 1px $color__line--item;
    border-right: solid 1px $color__line--item;
    border-left: solid 1px $color__line--item;
    &:last-child {
      border-bottom: solid 1px $color__line--item;
    }
    &--sp {
      font-size: 1rem;
    }
  }
  &__summary {
    padding: 17px 24px 0;
    color: $color__title;
    font-size: 1.5rem;
    line-height: 1.9;
    letter-spacing: 0.03em;
    display: flex;
    align-items: baseline;
    counter-increment: purchase;
    // &::before {
    //   content: counter(purchase);
    //   background: $color__title;
    //   width: 15px;
    //   height: 15px;
    //   border-radius: 50%;
    //   color: #fff;
    //   font-size: 1rem;
    //   line-height: 1;
    //   flex: 0 0 auto;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    // }
    &--sp {
      padding: 14px 19px 0;
      font-size: 1.1rem;
      display: block;
    }
  }
  &__counter {
    flex: 0 0 auto;
    &__simlator-link{
      text-decoration:underline;
      &:hover{
        text-decoration: none;
      }
    }
  }
  &__show-model {
    margin-left: 1em;
    text-decoration: underline;
    flex: 0 0 auto;
    align-self: flex-start;
    cursor: pointer;
    &:hover {
      text-decoration: none;
    }
    &::before {
      content: '[';
    }
    &::after {
      content: ']';
    }
    &--sp {
      margin-left: 0;
      display: inline-block;
    }
  }
  &__colors {
    padding: 24px;
    &--sp {
      padding: 19px;
    }
  }
  &__sizes {
    padding-top: 17px;
    &--sp {
      padding: 19px;
    }
  }
  &__quantity {
    padding: 17px 29px 19px;
    &--sp {
      padding: 14px 19px 19px;
    }
  }
  &__parts {
    padding: 17px 29px 29px;
    &--sp {
      padding: 14px 19px 19px;
    }
  }
  &__price {
    padding: 24px 29px 39px 24px;
    &--sp {
      padding: 0 0 19px;
    }
  }
}
</style>
